<div *ngIf="siteInfo.info || siteInfo.youtubeId" class="site-viewer-element">
  <div class="label t_t_u" >
  <div class="divider clearfix"></div>
    <!-- <p>{{title}}<p> -->
  </div>
    <div class="profile-card__heading" [innerHTML]="siteInfo.info | safeHtml"></div>
    <app-youtube-video [link]="siteInfo.youtubeId"></app-youtube-video>
</div>
  